module.exports = __webpack_public_path__ + "img/pt-9.327e5fe7.jpg";